import { Box } from "@chakra-ui/react";
import { useCallback } from "react";
import SkippedStatus from "components/Status/SkippedStatus";
import SentStatus from "components/Status/SentStatus";
import { PrimarySendNowButton } from "features/Issues/Components/Button/SendNowButton";
import { GraySkipButton } from "features/Issues/Components/Button/SkipButton";
import { useQueryClient } from "@tanstack/react-query";
import { updateIssueActionList, useActionIssuesResolvedQuery } from "features/Issues/hooks";
import { newHireJourneyKeys } from "features/NewHireJourney/hooks";
import { ActionSummary, ActionV2 } from "features/Resources/Shared/models";
import { actionStatusInfo, extractAction } from "features/Resources/Shared/helpers";

export default function ActionRowResolutionButtons({ action, issueId }: {
  action: ActionV2 | ActionSummary,
  issueId?: string,
}) {
  const resolvedAction = extractAction(action);
  const { data } = useActionIssuesResolvedQuery(resolvedAction?.prefixId);
  const issueCount = data?.nonTiming?.unresolvedCount;
  const queryClient = useQueryClient();

  const onSuccess = useCallback((resp: any) => {
    if (issueId) {
      updateIssueActionList({ queryClient, issueId, action: resp });
      queryClient.invalidateQueries({ queryKey: newHireJourneyKeys.withActiveIssuesList() });
    }
  }, [issueId, queryClient]);

  if (!resolvedAction) {
    return null;
  }
  const { isDone } = actionStatusInfo(resolvedAction);

  if (resolvedAction?.status === "skipped") {
    return (
      <Box display="flex" alignItems="center" gap="2">
        <SkippedStatus action={resolvedAction} />
        <GraySkipButton onSuccess={onSuccess} action={resolvedAction as ActionV2} />
      </Box>
    );
  } else if (isDone) {
    return (
      <Box display="flex" alignItems="center" gap="2">
        <SentStatus action={resolvedAction} />
      </Box>
    );
  }
    return (
      <Box display="flex" alignItems="center" gap="2">
        <PrimarySendNowButton isDisabled={issueCount === undefined || issueCount !== 0} onSuccess={onSuccess} minWidth="96px" action={resolvedAction} />
        <GraySkipButton onSuccess={onSuccess} action={resolvedAction} />
      </Box>
    );

}
